import React from "react";

import { SchedulerInstanceProvider } from "@INTEGRATIONS/scheduler/context";

export function SchedulerRootProvider({
    children, //
}: ChildrenProps) {
    return <SchedulerInstanceProvider>{children}</SchedulerInstanceProvider>;
}
